import { ReactNode } from 'react';

import classNames from 'classnames';

import './styles/label.scss';

type FormLabelProps = {
  checkbox?: true,
  children: ReactNode,
  className?: string,
  hidden?: boolean,
  htmlFor?: string
}

const FormLabel = ({
  className,
  hidden,
  htmlFor,
  children,
  checkbox,
}:FormLabelProps) => {
  return (
    <label
      className={ classNames('form-field--label', { 'checkbox' : !!checkbox }, { 'is-sr-only': !!hidden }, className) }
      htmlFor={ htmlFor }
    >
      {children}
    </label>
  );
};

export default FormLabel;
